import { CurrencyPipe } from '../../filters/currency.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { CardInvoicesComponent } from '../../components/card-invoices/card-invoices.component';
import { CardTransactionsComponent } from '../../components/card-transactions/card-transactions.component';
import { ListTabsComponent } from '../../components/list-tabs/list-tabs.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import UserService from '../../services/user.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import RoutingService from '../../services/routing.service';
import { PanelDirective } from '../../directives/panel.directive';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'wallet',
	templateUrl: './wallet.component.html',
	imports: [
		CommonModule, PanelDirective, CurrencyPipe, TranslatePipe,
		CardInvoicesComponent, CardTransactionsComponent, ListTabsComponent,
		FormsModule
	]
})
export default class WalletView implements OnInit, OnDestroy {
	private session: Session = inject(Session);
	private userService: UserService = inject(UserService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	walletSubscription: Subscription = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('wallet').then(() => {
			this.onResolve();
		});
	}
	
	ngOnDestroy() {
		if (this.walletSubscription) {
			this.walletSubscription.unsubscribe();
		}
	}
	
	onResolve() {
		this.vm.user = this.session.getSession().user;
		this.vm.type = 0;
		this.vm.tabs = [{
			label: this.angularFilterHelperService.translate('Wallet.Title.Recent')
		}, {
			label: this.angularFilterHelperService.translate('Invoices.Title')
		}];
		
		// this.angularStateHelperService.scopeWF(this, this.userService.getWallet, this.handleWalletChange, true);
		this.walletSubscription = this.angularBroadcastHelperService.onEvent(this, "walletChanged", (event, newWallet) => {
			this.handleWalletChange(newWallet);
		});
		var newWallet = this.userService.getWallet(); // TODO ANGULAR_2: should this be inside an interval?
		this.handleWalletChange(newWallet);
	}
	
	handleWalletChange(newWallet) {
		if (this.angularHelperService.equals(newWallet, this.vm.balance)) return;
		this.vm.balance = newWallet || {};
		if (newWallet && newWallet.businessWallet) {
			var sessionLimit: any = newWallet.businessWallet.sessionLimit != null ? newWallet.businessWallet.sessionLimit : 0;
			var sessionsUsed: any = newWallet.businessWallet.sessionsUsed != null ? newWallet.businessWallet.sessionsUsed : 0;
			this.vm.sessionsLeft = sessionLimit - sessionsUsed;
		}
	}
	
}